export class HhgBookShipmentAccessorialMsgs {
        public accessorialsMsgId: number;
        public bookAccessorialsId: number;
        public message: string = "";
  
}